import Vue from 'vue'
import BaseButton from '../../components/BaseButton/BaseButton.vue'
import AffiliateModal from '../../components/AffiliateModal/AffiliateModal.vue'
export default Vue.extend({
    name: 'Affiliate',
    components: {
        BaseButton,
        AffiliateModal
    },
    data() {
        return {
            clicked: false,
            review: 0
        }
    },
    methods: {
            change(value) {
                this.clicked = value
            },
            join(value) {
                this.review = value
            }
    }
})